// Mensagens cruas do backend que não têm valor para o usuário (em inglês e sem tradução)
const GENERIC_BACKEND_MESSAGES = ['authentication required'];

export function isGenericBackendMessage(message?: string): boolean {
  if (!message) return true;
  return GENERIC_BACKEND_MESSAGES.includes(message.trim().toLowerCase());
}
